export var toUtf8 = function toUtf8(input) {
  return new TextDecoder("utf-8").decode(input);
};